export default __webpack_public_path__ + "static/media/kw.04142ebd.PNG";